module.exports = __webpack_public_path__ + "static/img/img-wx.863f681.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-wx.png
// module id = eRAg
// module chunks = 0